/**
 * Why a booking could not be placed.
 *
 * Some of these are facts about the trip that nobody can overrule — there is no seat, the vehicle
 * already drove past, the trip is over. The rest only say the service is configured not to allow
 * something, and an administrator may accept them and carry on; the backend decides which is which
 * and only ever sends warnings for the second kind.
 */
export enum ReservationFailureReason {
  FullCapacity = 'FullCapacity',
  ReservationExceedsTime = 'ReservationExceedsTime',
  AlreadyVisited = 'AlreadyVisited',
  Impossible = 'Impossible',
  RouteIncompatible = 'RouteIncompatible',
  NoAvailabilitiesFound = 'NoAvailabilitiesFound',
  MaxVariationExceeded = 'MaxVariationExceeded',
  StopParkingImpossible = 'StopParkingImpossible',
  TransferNotFeasible = 'TransferNotFeasible',
  ReservationOnReadyNotAllowed = 'ReservationOnReadyNotAllowed',
  LastMinuteNotAllowed = 'LastMinuteNotAllowed',
  StopsNotInExpedition = 'StopsNotInExpedition',
  CancellationOnReadyNotAllowed = 'CancellationOnReadyNotAllowed',
  RealTimeChangeNotAllowed = 'RealTimeChangeNotAllowed',
  ReservationLimitExceeded = 'ReservationLimitExceeded',
  CancellationLimitExceeded = 'CancellationLimitExceeded',
  PathRestricted = 'PathRestricted',
  DistanceLimitExceeded = 'DistanceLimitExceeded',
  OutsideServiceOutline = 'OutsideServiceOutline',
  ExpeditionNoLongerOpen = 'ExpeditionNoLongerOpen',
  UserPenalised = 'UserPenalised',
}
